import { axiosClient } from "@iso/helpers/axios.config";
import { API_ENDPOINT } from "@iso/config/index";

const roleApi = {
   getRolesByUserId: () => {
      return axiosClient.get(`${API_ENDPOINT}/api/identity/users/my-roles`);
   }
}
export default roleApi;